const modalCreateNote = {
  header: 'Create note',
  btnCancel: 'Cancel',
  btnOk: 'OK',
};

export default modalCreateNote;
